module.exports = __webpack_public_path__ + "assets/GoldSigma2x.d5dfc8ac1983df2f0ddcacf3bc3cae20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldSigma2x.png
// module id = 822
// module chunks = 0